import script from "./LinkTwitterHype.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkTwitterHype.vue?vue&type=script&setup=true&lang=js"

import "./LinkTwitterHype.vue?vue&type=style&index=0&id=3e2417b2&lang=scss"

const __exports__ = script;

export default __exports__